import { makeStyles } from '@material-ui/styles';

export const useEditPostQuoteOptionsStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 3),
    overflowY: 'auto',
  },
}));
